import React, { useEffect, useState } from 'react';

const Timer = ({
  examtimeallowed,
  timeUp,
  isSubmitted,
}) => {
  const getInitialTime = (timeAllowed) => {
    const totalSeconds = Math.ceil(
      Number(timeAllowed || 0) * 60
    );

    return totalSeconds;
  };

  const [timeLeft, setTimeLeft] = useState(
    getInitialTime(examtimeallowed)
  );

  /**
   * Reset the timer whenever the actual exam time changes.
   *
   * This is important because Redux initially starts with
   * ExamTimeAllowed = 90 and later updates to the value
   * returned from the API.
   */
  useEffect(() => {
    const newTime = getInitialTime(examtimeallowed);

    setTimeLeft(newTime);
  }, [examtimeallowed]);

  /**
   * Countdown timer
   */
  useEffect(() => {
    if (isSubmitted || timeLeft <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((previousTime) => {
        if (previousTime <= 1) {
          clearInterval(interval);
          return 0;
        }

        return previousTime - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [isSubmitted, timeLeft]);

  /**
   * Trigger timeUp once the timer reaches zero
   */
  useEffect(() => {
    if (!isSubmitted && timeLeft === 0) {
      timeUp();
    }
  }, [timeLeft, isSubmitted, timeUp]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="timer-text">
      {!isSubmitted ? (
        timeLeft === 0 ? (
          'Time is Up!'
        ) : (
          <h1>
            {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
          </h1>
        )
      ) : (
        <h1>COMPLETED</h1>
      )}
    </div>
  );
};

export default Timer;

